import { Component } from "@angular/core";
import { TableIndexActionComponent } from "../table-index-action/table-index-action.component";

@Component({
  selector: "app-table-index-view-action",
  templateUrl: "./table-index-view-action.component.html",
  styleUrls: ["./table-index-view-action.component.scss"],
})
export class TableIndexViewActionComponent extends TableIndexActionComponent {}
